import { render, staticRenderFns } from "./ActivityFormPanelDatePhoneCall.vue?vue&type=template&id=2ac5063c&scoped=true&"
import script from "./ActivityFormPanelDatePhoneCall.vue?vue&type=script&lang=js&"
export * from "./ActivityFormPanelDatePhoneCall.vue?vue&type=script&lang=js&"
import style0 from "./ActivityFormPanelDatePhoneCall.vue?vue&type=style&index=0&id=2ac5063c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ac5063c",
  null
  
)

export default component.exports